import axiosClient from "./axiosClient";

export const dashboardCliente = (cuentaId) => axiosClient.get(`/dashboard/cliente/${cuentaId}`).then((r) => r.data);
export const dashboardAdmin = () => axiosClient.get("/dashboard/admin").then((r) => r.data);
